'use strict';

var moment = require('moment');
var TDChartDowAggregationFactory = function TDChartDowAggregationFactory(DataAggregationFactory, ExtractMetricKeysService) {
  var DOW = moment.weekdaysShort();
  function TDChartDowAggregation() {
    DataAggregationFactory.call(this, 'any', 'thematic-demand-chart-any-dow');
  }
  TDChartDowAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartDowAggregation.constructor = TDChartDowAggregation;
  TDChartDowAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedDOW = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedDOW[data[index].departureDateMomentDDD])) {
        aggregatedDOW[data[index].departureDateMomentDDD].push(data[index]);
      } else {
        aggregatedDOW[data[index].departureDateMomentDDD] = [data[index]];
      }
    }
    keys = Object.keys(aggregatedDOW);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      metricKeys = ExtractMetricKeysService.extract(aggregatedDOW[keys[index]][0]);
      aggregationFunction(aggregatedDOW[keys[index]], metricKeys, reducedEntry);
      aggregatedDOW[keys[index]] = reducedEntry;
    }
    return this.sortAggregationResults(aggregatedDOW, function (dowIx) {
      return DOW.indexOf(dowIx);
    });
  };
  return TDChartDowAggregation;
};
TDChartDowAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = TDChartDowAggregationFactory;